<template>
    <div>
        <van-swipe :autoplay="3000">
            <van-swipe-item v-for="(image, index) in images" :key="index">
                <van-image @click="handleOpen(image)"  width="100%" height="100%" :src="image" />
            </van-swipe-item>
        </van-swipe>
    </div>
</template>

<script>
import { ImagePreview } from 'vant';

export default {
    name: 'imageView',
    props: {
        images: {
            type: Array,
            default: []
        }
    },
    methods: {
        handleOpen() {
            ImagePreview({
                images: this.images, startPosition: 0
            });
        },
    }
}
</script>

<style></style>